// :cow: Cosmose CONFIDENTIAL :iso:
import { Campaign } from '@med/app/home/campaign/model/campaign';
import { EstimatesDto } from '@med/app/home/campaign/model/estimates';


export interface CampaignState {
  campaign?: Campaign;
  estimates?: EstimatesDto;
}

export const initialState: CampaignState = {
  estimates: undefined,
  campaign: undefined,
};
